import { useT } from "@transifex/react";
import { formatScoreWithoutTrailingZero } from "../../../helpers/ScoringHelper";
import { getIsScoreShown } from "../../../helpers/StudentResultScoreReveal";
import type { StudentResultAnswer } from "../../../helpers/StudentResultModel";

interface StudentResultAnswerScoreProps {
    answer: StudentResultAnswer;
    isScored: boolean;
}

/**
 * The points reached on one answer. Renders nothing unless the test is scored *and* the reveal is on
 * (`getIsScoreShown`), so callers place it without gating it themselves.
 *
 * No correct-answer reveal: the share transform strips solutions from the student's copy, so there
 * is nothing to show until HALLOFUSS-6734 carries one into the result.
 */
const StudentResultAnswerScore = (props: StudentResultAnswerScoreProps) => {
    const t = useT();
    const t_pointsAbbreviated = t("P.", { _tags: "StudentResult, AnswerScore" });

    if (!getIsScoreShown(props.isScored)) return null;

    const reached = formatScoreWithoutTrailingZero(props.answer.reachedScore);
    const max = formatScoreWithoutTrailingZero(props.answer.maxScore);

    return (
        <p
            className="text-m font-semibold text-p6-grey-dark whitespace-nowrap shrink-0"
            data-testid="student-result-answer-score"
        >
            {`${reached} / ${max} ${t_pointsAbbreviated}`}
        </p>
    );
};

export default StudentResultAnswerScore;
